import { Fragment } from 'react';
import { IconSpark } from './icons';

const MARQUEE_ITEMS = [
  'Menus',
  'Live Orders',
  'Tables',
  'QR Ordering',
  'Kitchen Display',
  'Multi-Location',
  'AI Optimizer',
  'Dynamic Pricing',
  'Group Orders',
  'Analytics',
  'Roles & Teams',
];

const STATS = [
  { to: '128', dec: null, pre: null, suf: '/150', label: 'Active nodes in region' },
  { to: '99.9', dec: '1', pre: null, suf: '%', label: 'System uptime, last 90d' },
  { to: '12', dec: null, pre: '−', suf: '%', label: 'Avg ticket time, vs legacy' },
  { to: '18', dec: null, pre: '+', suf: '%', label: 'Average cover growth' },
];

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero-fx" aria-hidden="true">
        <span className="hfx-glow" />
        <span className="hfx-grid" />
        <span className="hfx-scan" />
      </div>
      <div className="hero-meta hero-meta-l">
        <span className="meta-vert">PLATEERA / EST. 2026 / PAKISTAN</span>
      </div>
      <div className="hero-meta hero-meta-r">
        <span className="meta-vert">DIGITAL · DINING · OS</span>
      </div>

      <div className="hero-inner">
        <div className="hero-pill reveal">
          <span className="hp-dot" />
          <span className="hp-text">Now onboarding</span>
        </div>

        <h1 className="hero-title display">
          <span className="line">
            <span className="w reveal-w">Digital</span>{' '}
            <span className="w reveal-w">dining,</span>
          </span>
          <span className="line">
            <span className="w reveal-w it">
              <em className="shine">made</em>
            </span>{' '}
            <span className="w reveal-w it">
              <em className="shine">simple.</em>
            </span>
            {/* <span className="title-rule" /> */}
          </span>
        </h1>

        <p className="hero-sub reveal">
          The operating system for modern restaurants. From the QR a guest scans
          — at the table, the counter, or their car — to the ticket your line
          cook fires: menus, orders, locations, and teams in one quietly
          powerful platform.
        </p>

        <div className="hero-actions reveal">
          <a href="#cta" className="btn btn-primary">
            <span>Request access</span>
            <svg viewBox="0 0 14 14" width="14" height="14">
              <path
                d="M2 7h10M7 2l5 5-5 5"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <a href="#walk" className="btn btn-ghost">
            <span>See the console</span>
            <span className="arrow-down">↓</span>
          </a>
          <div className="hero-proof">
            <div className="hp-avatars">
              <span>K</span>
              <span>M</span>
              <span>A</span>
            </div>
            <div className="hp-proof-text">
              <strong>4.9</strong> <span className="hp-stars">★★★★★</span>
              <br />
              loved by independent kitchens
            </div>
          </div>
        </div>

        {/* <div className="hero-foot reveal">
          {STATS.map((s, i) => (
            <div className="foot-cell" key={i}>
              <div className="foot-num">
                {s.pre && <span className="fpre">{s.pre}</span>}
                <span className="cv" data-to={s.to} data-dec={s.dec || undefined}>
                  0
                </span>
                <span className="fsuf">{s.suf}</span>
              </div>
              <div className="foot-label">{s.label}</div>
            </div>
          ))}
        </div> */}
      </div>

      <div className="hero-scroll-cue">
        <span className="cue-line" />
        <span className="cue-label">scroll</span>
      </div>

      <div className="hero-marquee" aria-hidden="true">
        <div className="marquee-track">
          {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
            <Fragment key={i}>
              <span>{item}</span>
              <i><IconSpark /></i>
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
